module.exports = __webpack_public_path__ + "img/exclamation.1cb65d52.svg";